import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setMinutes, setHours } from 'date-fns';
import CustomButton from '../../layout/customButton/CustomButton';
import Modal from '../../layout/modal/Modal';
import { rescheduleAppointment } from '../../../api/Agenda/agenda.api';
import styles from './RescheduleMeeting.module.scss';
import CustomAlerts from '../../alerts/CustomAlerts';

const RescheduleMeeting = (props) => {
	const {
		appointmentId,
		handleRescheduleModalClose,
		appointmentTime,
		setLoading,
		rescheduleModal,
	} = props;
	const [startDate, setStartDate] = useState(new Date());
	const [snackbar, setSnackbar] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [snackbarType, setSnackbarType] = useState('');

	const saveHandler = () => {
		let date = new Date(startDate);
		let timeInMillisec = date.getTime();
		rescheduleAppointment(
			appointmentId,
			timeInMillisec,
			(loading) => {
				setLoading(loading);
			},
			(message, type) => {
				displayAlert(message, type);
			}
		);
		handleRescheduleModalClose();
	};

	const displayAlert = (message, type) => {
		setSnackbar(true);
		setSnackbarMessage(message);
		setSnackbarType(type);
		setTimeout(() => {
			setSnackbar(false);
		}, 3500);
	};

	useEffect(() => {
		if (appointmentTime) {
			setStartDate(new Date(appointmentTime));
		}
	}, [appointmentTime]);

	return (
		<div className={styles.reschedule_meeting_modal}>
			<CustomAlerts
				alertType={snackbarType}
				alertMsg={snackbarMessage}
				snackbar={snackbar}
				setSnackbar={setSnackbar}
			/>
			<Modal
				show={rescheduleModal}
				close={handleRescheduleModalClose}
				title='Reschedule Meeting'
			>
				<div className={styles.reschedule_meeting}>
					<div
						className={styles.date_picker}
						style={{ minWidth: 330 }}
					>
						<DatePicker
							selected={startDate}
							onChange={(date) => setStartDate(date)}
							showTimeSelect
							timeFormat='HH:mm'
							timeIntervals={15}
							timeCaption='time'
							dateFormat='MMMM d, yyyy h:mm aa'
							width='200px'
							popperPlacement='top-center'
							minDate={Date.now()}
							minTime={setHours(setMinutes(new Date(), 0), 7)}
							maxTime={setHours(setMinutes(new Date(), 0), 20)}
						/>
					</div>
					<div className={styles.buttons}>
						<CustomButton
							width={160}
							height={42}
							onClick={saveHandler}
						>
							Save
						</CustomButton>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default RescheduleMeeting;
